import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const DEFAULT_TRANSLATION_LOCALE = 'en-us';

export const useTranslationWithFallback = (
    translate: TranslateService,
    locale: string | null | undefined,
    brand: string | null | undefined,
    fallbackLocale: string = DEFAULT_TRANSLATION_LOCALE,
): Observable<unknown> => {
    const normalizedBrand = (brand || '').toUpperCase();
    const normalizedLocale = locale || fallbackLocale;
    const language = `${normalizedLocale}.${normalizedBrand}`;
    const fallbackLanguage = `${fallbackLocale}.${normalizedBrand}`;

    if (language === fallbackLanguage) {
        return translate.use(language);
    }

    return translate.use(language).pipe(
        catchError(() => translate.use(fallbackLanguage))
    );
};
